interface PageHeaderProps {
  title: string;
  description: string;
}

export default function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
        {title}
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl">{description}</p>
    </div>
  );
}
